<template>
  <div class="d-desktop result__table" id="tableList">
    <div class="bootstrap-table">
      <div class="fixed-table-container">
        <div class="fixed-table-body">
          <table
            class="cruise-list-table table table-hover table-borderless"
            ref="tableElement"
          >
            <thead class="">
              <tr>
                <th data-field="ship" @click="setSort">
                  <div class="th-inner sortable both">Теплоход</div>
                  <div class="fht-cell"></div>
                </th>
                <th data-field="date_from" @click="setSort">
                  <div class="th-inner sortable both">Отход</div>
                  <div class="fht-cell"></div>
                </th>
                <th data-field="date_to" @click="setSort">
                  <div class="th-inner sortable both">Прибытие</div>
                  <div class="fht-cell"></div>
                </th>
                <th data-field="days" @click="setSort">
                  <div class="th-inner sortable both">Дней</div>
                  <div class="fht-cell"></div>
                </th>
                <th data-field="seasonRoute" @click="setSort">
                  <div class="th-inner">Маршрут</div>
                  <div class="fht-cell"></div>
                </th>

                <th data-field="min_price" @click="setSort">
                  <div class="th-inner sortable both">Цена от</div>
                  <div class="fht-cell"></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <CruiseListViewTableTr
                :item="item"
                v-for="item in items"
                :key="item.id"
              />
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CruiseListViewTableTr from "./CruiseListViewTableTr";

export default {
  name: "CruiseListViewTable.vue",
  components: {
    CruiseListViewTableTr,
  },
  computed: {
    ...mapGetters(["items"]),
    tableElement() {
      return this.$refs.tableElement;
    },
  },
  methods: {
    setSort: function (event) {
      let thisElement = event.currentTarget,
        currentSortable = thisElement.querySelector(".sortable"),
        sortable = this.tableElement.querySelectorAll(".sortable"),
        sortReverse = false;
      sortable.forEach((element) => {
        if (element != currentSortable) {
          element.classList.remove("asc", "desc");
        }
      });
      if (currentSortable.classList.contains("asc")) {
        currentSortable.classList.remove("asc");
        currentSortable.classList.add("desc");
        sortReverse = true;
      } else {
        currentSortable.classList.remove("desc");
        currentSortable.classList.add("asc");
      }
      this.$store.dispatch("setSort", {
        key: thisElement.dataset.field,
        reverse: sortReverse,
      });
    },
  },
};
</script>
